import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user/user.services';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import swal from 'sweetalert2';
@Component({
  selector: 'app-add-subprofile',
  templateUrl: './add-subprofile.component.html',
  styleUrls: ['./add-subprofile.component.scss']
})
export class AddSubprofileComponent implements OnInit {

  addSubProfileTitle = true;
  editSubProfileTitle=false;
  profileList=[];
  subprofileform: FormGroup;  
  constructor(private formBuilder: FormBuilder,private userService:UserService) { 
    this.getFromGroup();
  }

  ngOnInit() {
    this.loadMasters();
  }
loadMasters(){
    this.userService.getProfile().subscribe(response => {
      this.profileList = response['result'];
    })
 
}
get f() { return this.subprofileform.controls; }

  private getFromGroup() {
    this.subprofileform = this.formBuilder.group({
      'secSubProId':[null],
      'secProId': [new FormControl(), Validators.required],
      'secProDefaultOpenPage': new FormControl(),
      'secProDesc': new FormControl(),
      'secProDescEn': new FormControl(),
      'staRecCode':[true]
    })
  }
  patchSubProfileValue(result){
    this.subprofileform.patchValue({
      secSubProId:result["secSubProId"],
      secProId:result["secProId"],
      secProDefaultOpenPage:result["secProDefaultOpenPage"],
      secProDesc:result["secProDesc"],
      secProDescEn:result["secProDescEn"],
      staRecCode:result["staRecCode"] ==='A' ? true :false
       });
  }
  save(){
    this.subprofileform.patchValue({ staRecCode: this.f.staRecCode.value ? 'A' : 'I'});
    this.userService.saveSubProfile(this.subprofileform.value).subscribe(response => {
      if (response && response["code"]==0) {
        this.subprofileform.patchValue({secSubProId: response['result']});
        swal.fire("Success", response['message'], 'success');
      }else{
        swal.fire("Error", response['message'], 'error');
      }
    })
  }
  reset(){
    this.subprofileform.reset();
  }
}
